import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { miniTable } from "MODULES/shared/decorators";
import withSubscription from "MODULES/Subscription/withSubscription";
import { shortDateYY } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { CONDITIONS } from "MODULES/SalesOrders/constants";
import classNames from "classnames";
import { get } from "lodash"; // <--- Added for brokeredSale only
import {
  DataTable,
  LinkedTableRow,
  IconText,
  CompanyName
} from "MODULES/shared/components";
import SalesOrderLineItemStatusCell from "MODULES/shared/components/SalesOrderLineItemStatusCell";
import api from "APP_ROOT/api";
import { ExchangeIcon } from "MODULES/SalesOrders/helpers";
import { NoteTooltip } from "MODULES/shared/components/NoteTooltip";

const formatPrice = value => {
  if (value >= 1000) {
    return `$${Math.floor(value).toLocaleString()}`;
  }
  return dollars(value);
};

export class Table extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        company: PropTypes.shape({ name: PropTypes.string }),
        buyer: PropTypes.shape({ full_name: PropTypes.string }),
        condition: PropTypes.string.isRequired,
        quantity: PropTypes.number.isRequired,
        cost: PropTypes.string
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired
  };

  renderRow = (lineItem, i) => {
    const brokeredSale = get(lineItem, "inventory.brokered_sale", false);

    return (
      <LinkedTableRow
        key={i}
        to={`/sales-orders/${lineItem.sales_order_uuid}`}
        cancelled={lineItem.cancelled || lineItem.credit_exchange}
      >
        <td>{i + 1}</td>
        <SalesOrderLineItemStatusCell
          shipped={lineItem.shipped}
          cancelled={lineItem.cancelled}
        >
          {lineItem.after_hours &&
            !lineItem.internal_outright && (
              <IconText note="After Hours" margin="5px" icon="fa-clock-o" />
            )}
          {lineItem.customer_rmas.filter(c => !c.cancelled).length > 0 && (
            <IconText note="Cust. RMA" margin="5px" icon="fa-cog" />
          )}
          {lineItem.internal_outright && (
            <IconText text="io" note="Internal Outright" />
          )}

          {brokeredSale && (
            <IconText
              note="Brokered"
              icon="fa-bolt"
              margin="5px"
              color="#4787F8" // Force a lighter blue
              iconSize="fa-stack-1x"
            />
          )}
        </SalesOrderLineItemStatusCell>
        <td>{shortDateYY(lineItem.created_at)}</td>
        <td className="text-nowrap">
          <CompanyName flattenedCompany={lineItem} truncateAt={18} />
        </td>
        <td className="text-nowrap">
          {lineItem.seller &&
            getFirstNameLastInitial(lineItem.seller.full_name)}
        </td>
        <td className="text-nowrap">{lineItem.serial_number}</td>
        <td className="text-nowrap">
          {lineItem.condition && CONDITIONS[lineItem.condition].abbrev}
        </td>
        <td className="text-center">
          <ExchangeIcon lineItem={lineItem} />
        </td>
        <td className="text-center">{lineItem.quantity}</td>
        <td className="text-right">
          {lineItem.exchange_sale
            ? formatPrice(lineItem.exchange_fee)
            : formatPrice(lineItem.price_per_unit)}
        </td>
        <td>
          {(lineItem.internal_note || lineItem.external_note) && (
            <NoteTooltip
              note={[lineItem.internal_note, lineItem.external_note]
                .filter(n => n !== null && n !== "")
                .join(" | ")}
              className={classNames({ "link-muted": lineItem.cancelled })}
            />
          )}
        </td>
      </LinkedTableRow>
    );
  };

  render() {
    const { loading, results } = this.props;

    return (
      <DataTable.Mini loading={loading} numbered>
        <DataTable.Head>
          <th />
          <th />
          <th>Date</th>
          <th>Customer</th>
          <th>SELLER</th>
          <th>SN</th>
          <th>CD</th>
          <th>Exch</th>
          <th className="text-center">QTY</th>
          <th className="text-right">Price/Unit</th>
          <th>Note</th>
        </DataTable.Head>
        <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.salesOrderLineItems.search(match.params.id, params)
);

export default withRouter(
  withResults(withSubscription("SalesOrderLineItem")(Table))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/SalesOrders/Table.jsx